import { Input } from '@lib/components'
import { Button } from '@octopus-do/octopus-storybook'
import { Clone } from '@octopus-do/octopus-storybook/icons'
import { useRef } from 'react'
import { useDispatch } from 'react-redux'

import { GlobalActions } from '@/store'
import css from './Clipboard.module.scss'

type Props = {
  disabled?: boolean
  defaultValue: string
  onCopy?: () => void
}

const Clipboard: React.FC<Props> = ({
  disabled = false,
  defaultValue,
  onCopy,
}) => {
  const dispatch = useDispatch()

  const inputRef = useRef<HTMLInputElement>(null)

  const onButtonClick = async () => {
    if (!inputRef?.current) {
      return
    }

    inputRef.current.select()
    dispatch(GlobalActions.copy({ value: inputRef.current.value }))
    onCopy?.()
  }

  return (
    <div className={css.container}>
      <input ref={inputRef} defaultValue={defaultValue} hidden />
      <Input
        type="normal"
        initialValue={defaultValue}
        disabled={disabled}
        readOnly
      />
      <Button left={Clone} aria-label="Copy link" onClick={onButtonClick} />
    </div>
  )
}

export default Clipboard
